import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class AMOStatusUseCase extends BaseUseCase {
    constructor(Repo) {
        super();
        this.Repo = Repo;
    }
    async fetchResult(req) {
        return await this.Repo.AMOStatus(req);
    }
}
export default AMOStatusUseCase;
